module.exports = __webpack_public_path__ + "system/img/quick-icon-09.b4d8c013.png";